import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { RouterLink } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'

import { UserAccessComponent } from '~/core/components'
import { DestroyDirective } from '~/core/directives'
import { EForecastRisk, EGuardEntityName, EGuardSectionName, IForecastDto } from '~/core/models'
import { ForecastCompanySize, ForecastNumber } from '~/shared/pipes'

@Component({
  selector: 'app-company-header-card',
  templateUrl: './company-header-card.component.html',
  styleUrl: './company-header-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [
    DatePipe,
    RouterLink,
    MatIconModule,
    ForecastNumber,
    TranslateModule,
    MatButtonModule,
    MatDividerModule,
    UserAccessComponent,
    ForecastCompanySize,
  ],
})
export class CompanyHeaderCardComponent {
  readonly showHomePageLink = input(false)
  readonly guardSectionName = input<EGuardSectionName | null>()
  readonly forecast = input<IForecastDto | null>(null)

  EGuardEntityName = EGuardEntityName
  EForecastRisk = EForecastRisk
  announceDate = new Date()

  constructor() {
    effect(() => {
      const forecast = this.forecast()

      if (forecast && forecast.announceDays < -1 && forecast.qrtrEndDate) {
        this.announceDate = new Date(forecast.qrtrEndDate)
        this.announceDate = new Date(
          this.announceDate.getFullYear(),
          this.announceDate.getMonth() + 4,
          0
        )
      }
    })
  }
}
